import { render, staticRenderFns } from "./ManageDivisions.vue?vue&type=template&id=3823e907"
import script from "./ManageDivisions.vue?vue&type=script&lang=js"
export * from "./ManageDivisions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports